import { useEffect, useState } from "react";
import { Row } from "react-bootstrap";
import api from "@/api/api.js";

const ContadorBills = () => {
  const [stats, setStats] = useState({ pendingToAttend: 0, workingByMe: 0 });

  useEffect(() => {
    api
      .get("/billings/dashboard/stats")
      .then(({ data }) =>
        setStats({
          pendingToAttend: data.pendingToAttend ?? 0,
          workingByMe: data.workingByMe ?? 0,
        }),
      )
      .catch(() => setStats({ pendingToAttend: 0, workingByMe: 0 }));
  }, []);

  return (
    <Row>
      <div className="col-xxl-4 col-md-6">
        <div className="card info-card sales-card">
          <div className="card-body">
            <h5 className="card-title">Facturas pendientes por atender</h5>
            <div className="d-flex align-items-center">
              <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                <i className="bi bi-inbox"></i>
              </div>
              <div className="ps-3">
                <h6>{stats.pendingToAttend}</h6>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-xxl-4 col-md-6">
        <div className="card info-card sales-card">
          <div className="card-body">
            <h5 className="card-title">Facturas que estás trabajando</h5>
            <div className="d-flex align-items-center">
              <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                <i className="bi bi-pencil-square"></i>
              </div>
              <div className="ps-3">
                <h6>{stats.workingByMe}</h6>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Row>
  );
};

export default ContadorBills;
